import React from 'react';
import classNames from 'classnames/bind';
import style from "./styles.pcss";
var cx = classNames.bind(style);
export var VideoPlayer = function VideoPlayer(_ref) {
  var poster = _ref.poster,
    src = _ref.src,
    rutubeId = _ref.rutubeId,
    youtubeId = _ref.youtubeId,
    autoplay = _ref.autoplay;
  var iframeSrc = '';
  if (rutubeId) {
    iframeSrc = "https://rutube.ru/play/embed/".concat(rutubeId);
  }
  if (youtubeId) {
    iframeSrc = "https://www.youtube.com/embed/".concat(youtubeId);
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, iframeSrc && /*#__PURE__*/React.createElement("iframe", {
    className: cx('iframe'),
    frameBorder: "0",
    src: iframeSrc,
    title: "video",
    "data-t-id": "components-VideoPlayer"
  }), !iframeSrc && src && /*#__PURE__*/React.createElement("video", {
    autoPlay: autoplay,
    className: cx('video'),
    controls: true,
    muted: autoplay
    // @ts-ignore
    ,
    playsinline: 1
    /* eslint-disable-next-line @typescript-eslint/ban-ts-comment */,
    poster: poster,
    src: src
  }));
};